import { getAdminErrorMessage } from '../adminErrorModel'
import { MerchantStatusData } from '../../../domain/invoicing/rainforest'

export const getResetBlockedReason = (data: MerchantStatusData): string | null => {
  if (data.merchantId === '' && data.applicationId === '') {
    return 'This tenant has no payments application to reset.'
  }
  if (data.merchantStatus === 'ACTIVE') {
    return 'This merchant is ACTIVE. Live merchants cannot be reset because payments reference them.'
  }
  return null
}

export const getResetErrorMessage = (error: unknown): string => {
  return getAdminErrorMessage(error, 'Failed to reset the payments application. Please try again.')
}

export const formatStatusLabel = (status: string): string => {
  if (status.trim() === '') {
    return 'NONE'
  }
  return status
}

export const getMerchantStatusColor = (status: string): string => {
  switch (status) {
    case 'ACTIVE':
      return 'green'
    case 'ONBOARDING':
      return 'blue'
    case 'CANCELED':
      return 'red'
    default:
      return 'default'
  }
}

export const getApplicationStatusColor = (status: string): string => {
  switch (status) {
    case 'COMPLETED':
      return 'green'
    case 'DECLINED':
      return 'red'
    case 'NEEDS_INFORMATION':
      return 'orange'
    case 'PROCESSING':
    case 'IN_REVIEW':
      return 'gold'
    case 'CREATED':
    case 'IN_PROGRESS':
      return 'blue'
    default:
      return 'default'
  }
}
